// Where "get the mobile app" points. One copy, shared by the /get-app page and the home's
// download-the-app card, so the two can't drift onto different listings.
//
// The mobile app is "Orion by Wix" (App Store id6737450738 / Play com.wix.time). All three links are
// public, verified store handles.

export const IOS_URL = 'https://apps.apple.com/app/id6737450738';
export const ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.wix.time';
export const IOS_APP_STORE_ID = '6737450738';

/**
 * The JotURL smart link (config key DOWNLOAD_APP_JOTURL_BASE) device-detects and routes to the right
 * store, and carries deferred deep-linking — so one QR serves iOS, Android, and desktop scanners.
 */
export const APP_SMART_LINK = 'https://invite.mobileappinvite.com/time';

/**
 * The Wixel app's store listings — where "Get the Wixel app" in the Edit-in-Wixel choice sheet points
 * (`lib/wixel-edit-choice.ts`) when the editor URL has no `apps.wixel.com` app link (which reaches the store
 * by itself when the app is missing). The same two listings the iOS and Android apps' own choice sheet opens.
 */
export const WIXEL_IOS_URL = 'https://apps.apple.com/app/id6748279924';
export const WIXEL_ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.wix.wixel';
